module.exports = __webpack_public_path__ + "img/img002.b26603c3.png";